/**
 * タグ単位のメモリキャッシュ（NFR Design 3.1: Per-Tag-Instance Memory Cache）。
 * タグ間（同一ページ内の別ポップアップ用タグ）で共有しない。
 * 各タグのエントリーポイント（entry.ts）内でインスタンス化して利用する。
 */
export class TagCache<K, V> {
  private readonly store = new Map<K, V>();

  get(key: K): V | undefined {
    return this.store.get(key);
  }

  set(key: K, value: V): void {
    this.store.set(key, value);
  }

  has(key: K): boolean {
    return this.store.has(key);
  }

  clear(): void {
    this.store.clear();
  }
}

/**
 * タグインスタンスごとに新規のキャッシュを生成するファクトリ。
 * entry.tsの初期化処理内で呼び出し、他タグとは共有しないインスタンスを保持する。
 */
export function createTagCache<K, V>(): TagCache<K, V> {
  return new TagCache<K, V>();
}
